<template>
  <div>
    <Header class="mb-4" />
    <div class="container-fluid container-xxl mb-5">
      <slot name="breadcrumbs" />

      <div class="row">
        <slot name="sidebar" />
        <div class="col">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header';

export default {
  name: 'BaseLayout',
  components: { Header },
};
</script>
